module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-more.8b1952fb.png";